/**
 * Element pages that search engines may index. An element page goes on this list once it has at least
 * MIN_INDEXABLE_PROSE_WORDS words of its own written prose (not counting the generated "X + Y" reaction
 * lists or the facts grid), which in practice means it has a write-up in elementArticles.js.
 * Pages not listed still work and stay linked, but carry <meta name="robots" content="noindex, follow">,
 * are left out of sitemap.xml and show no ads.
 *
 * sitePages.test.js checks that every slug here has a long enough article.
 */
export const INDEXABLE_ELEMENT_SLUGS = Object.freeze([
  'hydrogen',
  'helium',
  'lithium',
  'carbon',
  'nitrogen',
  'oxygen',
  'fluorine',
  'neon',
  'sodium',
  'magnesium',
  'aluminium',
  'silicon',
  'phosphorus',
  'sulfur',
  'chlorine',
  'argon',
  'potassium',
  'calcium',
  'titanium',
  'iron',
  'copper',
  'zinc',
  'bromine',
  'silver',
  'tin',
  'iodine',
  'platinum',
  'gold',
  'mercury',
  'lead',
  'uranium',
  'beryllium',
  'boron',
  'chromium',
  'manganese',
  'cobalt',
  'nickel',
  'gallium',
  'germanium',
  'arsenic',
  'krypton',
  'rubidium',
  'strontium',
  'zirconium',
  'molybdenum',
  'palladium',
  'cadmium',
  'xenon',
  'caesium',
  'barium',
  'neodymium',
  'tungsten',
  'bismuth',
  'radon',
  'radium',
  'plutonium',
]);
